import { z } from "zod";

/**
 * Skema untuk respons dari endpoint DELETE /dynamic-pricing/group/{id}.
 * Memastikan bahwa operasi berhasil dan tidak ada data entitas yang dikembalikan.
 */
export const DeleteDynamicPricingGroupResponseSchema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number().int(),
    // Data diharapkan null karena entitas telah dihapus.
    data: z.null(),
});

export type DeleteDynamicPricingGroupResponse = z.infer<typeof DeleteDynamicPricingGroupResponseSchema>;